<template>
  <div :class="themeStyleVs === 2 ? 'gz_page black_box' : 'gz_page'">
    <ul class="type_nav_box">
      <li
        v-for="item in typeNav"
        :key="item.id"
        :class="typeId === item.id ? 'active' : ''"
        @click="checkNav(item.id)"
      >
        {{ item.name }}
      </li>
    </ul>

    <p class="num_main">共{{ total }}个</p>
    <div class="content_main" v-if="typeId === 'yz'">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="scrollYzFn"
        class="ul"
      >
        <li v-for="(item, index) in listData" :key="index" @click.stop="goDetailYz(item)">
          <img
            class="top_img"
            v-if="item.sort_top === 1"
            src="../../assets/image/zdtype.png"
            alt=""
          />
          <div class="tit">
            <span>{{ item.s_name }}</span>
            <img :src="themeStyleVs === 2 ? dian_block : dian" alt="" @click.stop="yzProp(item)" />
          </div>
          <div class="xifen_box">{{ item.XiFenZhongLei }}</div>
          <div class="chart_main">
            <div class="left">
              <p :class="item.RiZhangFu | formateRedGreen">
                {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
              </p>
              <p>今日涨幅</p>
            </div>
            <div class="right">
              <div class="chart_box" :id="'chartyz' + index"></div>
              <div :class="item.yearsData | bgColor">
                <p>近一年</p>
                <p :class="item.yearsData | formateRedGreen">
                  {{ toFixedNum(item.yearsData, 2, '%') }}
                </p>
              </div>
            </div>
          </div>
          <div class="cen_main">
            <p>
              <span>今日信号</span><span v-if="item">{{ item.XinHaoShuLiang }}只</span>
            </p>
            <p>
              <span>涨停</span
              ><span v-if="item"
                >{{
                  item.ZhangTingShu || item.ZhangTingShu === 0 ? item.ZhangTingShu : '--'
                }}只</span
              >
            </p>
            <p>
              <span>涨逾{{ ZhangYuShu }}%</span
              ><span v-if="item"
                >{{ item.ZhangYuShu || item.ZhangYuShu === 0 ? item.ZhangYuShu : '--' }}只</span
              >
            </p>
          </div>
          <div class="long_main">
            <div class="long_li" v-for="(longItem, longIndex) in item.LongTouGu" :key="longIndex">
              <span>{{ longItem.MingCheng }}</span>
              <span :class="longItem.ZhangFu | formateRedGreen">{{
                toFixedNum(longItem.ZhangFu, 2, '%')
              }}</span>
            </div>
          </div>
          <div class="kd_main">
            <img :src="themeStyleVs === 2 ? kdBlockImg : kdImg" alt="" />
            {{ item.KanDian }}
          </div>
        </li>
      </van-list>
      <van-empty
        v-if="!listData.length && finished"
        class="custom-image"
        :image="not_data"
        description="暂未获取到数据"
      />
    </div>
    <div class="content_main cl_content_main" v-if="typeId === 'cl'">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="scrollClFn"
      >
        <div
          class="cl_main"
          v-for="(item, index) in listData"
          :key="index"
          @click.stop="goClDetails(item)"
        >
          <img
            class="top_img"
            v-if="item.sort_top === 1"
            src="../../assets/image/zdtype.png"
            alt=""
          />
          <div class="top">
            <span class="tit">{{ item.s_name }}</span>
            <img :src="themeStyleVs === 2 ? dian_block : dian" alt="" @click.stop="yzProp(item)" />
          </div>
          <div class="intro_box">{{ item.s_desc }}</div>
          <div class="detail_cante">
            <div class="li_box">
              <div class="lf_box">
                <p :class="item.RiZhangFu | formateRedGreen">
                  {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
                </p>
                <p>日涨幅</p>
              </div>
              <div class="rg_box">
                <p>{{ item.XinHaoShuLiang }}只</p>
                <p>今日信号</p>
              </div>
            </div>
            <div class="li_box">
              <div class="lf_box">
                <p :class="item.BestAvgRate | formateRedGreen">
                  {{ toFixedNum(item.BestAvgRate * 100, 2, '%')
                  }}<span>持股{{ item.BestAvgCycle }}天</span>
                </p>
                <p>最优平均涨幅</p>
              </div>
              <div class="rg_box">
                <p :class="item.MaxRiseRate | formateRedGreen">
                  {{ toFixedNum(item.MaxRiseRate * 100, 2, '%')
                  }}<span>持股{{ item.MaxRiseCycle }}天</span>
                </p>
                <p>最大上涨概率</p>
              </div>
            </div>
          </div>
        </div>
      </van-list>

      <van-empty
        v-if="listData.length <= 0 && finished"
        class="custom-image"
        :image="not_data"
        description="暂未获取到数据"
      />
    </div>
    <!--  @scroll="scrollMn($event)" -->
    <div class="content_main mn_content_main" v-if="typeId === 'mn'">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="scrollMnFn"
      >
        <div class="list_main">
          <div
            class="cl_main"
            v-for="(item, index) in listData"
            :key="index"
            @click.stop="goMnDetails(item)"
          >
            <div class="lose_box" v-if="item.lastProfit.status === 0">
              <div class="btn_show">模拟交易已失效</div>
            </div>
            <img
              class="top_img"
              v-if="item.sort_top === 1"
              src="../../assets/image/zdtype.png"
              alt=""
            />
            <div class="top">
              <span class="tit">{{ item.s_name }}</span>
              <img
                :src="themeStyleVs === 2 ? dian_block : dian"
                alt=""
                @click.stop="yzProp(item)"
              />
            </div>
            <div class="cen_main">
              <ul>
                <li>
                  <p :class="item.lastProfit.totalRisk | formateRedGreen">
                    {{ toFixedNum(item.lastProfit.totalRisk * 100, 2, '%') }}
                  </p>
                  <p>累计收益</p>
                </li>
                <li>
                  <p :class="item.lastProfit.todayRisk | formateRedGreen">
                    {{ toFixedNum(item.lastProfit.todayRisk * 100, 2, '%') }}
                  </p>
                  <p>今日收益</p>
                </li>
                <li>
                  <p>{{ toFixedNum(item.lastProfit.maxRetreatRate * 100, 2, '%') }}</p>
                  <p>最大回撤</p>
                </li>
              </ul>
            </div>
            <div class="chart_box" :id="'chartMn2' + index"></div>
            <div class="food_box clearfix">
              <span class="time_box">自{{ convertTime(item.lineData.xData[0]) }}</span>
              <div class="right_box">
                <span>收益</span>
                <span>沪深</span>
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <van-empty
        v-if="queryShow && listData.length <= 0"
        class="custom-image"
        :image="not_data"
        description="暂未获取到数据"
      />
    </div>
    <van-popup v-model="popupShow" round position="bottom">
      <div class="popup_box">
        <ul class="controls_ul">
          <li
            v-if="typeId === 'mn' && popupData && popupData.lastProfit.status !== 0"
            @click="topMyFavorFn"
          >
            {{ popupData.sort_top === 1 ? '取消置顶' : '置顶' }}
          </li>
          <li v-if="popupData && typeId !== 'mn'" @click="topMyFavorFn">
            {{ popupData.sort_top === 1 ? '取消置顶' : '置顶' }}
          </li>
          <li @click="delFavorFn">取消关注</li>
        </ul>
        <div class="close_box" @click="popupShow = false">取消</div>
      </div>
    </van-popup>
    <van-dialog
      v-model="dialogShow"
      :message="dialogMessage"
      cancelButtonColor="#999"
      confirmButtonColor="#286DF7"
      className="dialog_box"
      showConfirmButton
      showCancelButton
      @confirm="dialogFnConfirm"
    >
    </van-dialog>
    <takeOut
      :show="takeShow"
      :name="takeName"
      :btnText="takeBtnName"
      :type="takeLinkType"
      @cancelBasis="cancelBasis"
      @linkGo="linkGo"
    ></takeOut>
  </div>
</template>

<script>
import mixins from '@/mixins/index.js';
import { getMyFavor, getFactorTrend, topMyFavor } from '@/api/my.js';
import { getFactorHq, delMyFavor, getClientRedis } from '@/api/index.js';
import { newFangDouFun,compareVersions } from '@/utils/format.js';

// import inobounce from 'inobounce'; //处理ios橡皮筋
import takeOut from '@/components/notHd/TakeOut.vue';
export default {
  name: 'Gz',
  mixins: [mixins],
  components: {
    takeOut
  },
  data() {
    return {
      dian: require('@/assets/image/dian.png'),
      dian_block: require('@/assets/image/blockImg/dian_img.png'),
      kdImg: require('@/assets/image/kd.png'),
      kdBlockImg: require('@/assets/image/blockImg/kdBlock.png'),
      ZhangYuShu: window.config.ZhangYuShu,
      hotTacticInterval: null, // 行情中定时器
      typeNav: [
        { name: '因子', id: 'yz' },
        { name: '多因子策略', id: 'cl' },
        { name: '模拟交易', id: 'mn' }
      ],
      typeId: 'yz',
      total: 0,
      page: 1,
      pageSize: 10,
      listData: [],
      chartList: [],
      factorID: '',
      mnChartList: [],
      popupShow: false,
      popupData: null,
      not_data: require('../../assets/image/notData.png'),
      queryShow: false,
      themeStyleVs: 1,
      dialogShow: false,
      dialogMessage: '',
      loading: false,
      finished: false,
      finishedText: '没有更多了',
      takeShow: false,
      takeName: '',
      takeBtnName: '',
      takeLinkType: '',
      linkData: ''
    };
  },
  filters: {
    bgColor: function (num) {
      if (num > 0) {
        return 'one_year_box red_bg';
      } else if (num < 0) {
        return 'one_year_box green_bg';
      }
    }
  },
  created() {
    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
    // let u = navigator.userAgent;
    // if (u.indexOf('iPhone') > -1) {
    //   inobounce.enable();
    // }
  },

  mounted() {
    this.typeId = this.$store.state.smallTab ? this.$store.state.smallTab : 'yz';
    // this.loading = true;
    // this.checkNav(this.typeId);
  },
  methods: {
    compareVersions,
    checkNav: function (id) {
      let that = this;
      if (that.typeId == id) return false;
      that.$store.commit('setSmallTab', id);
      that.loading = true;
      that.finished = false;
      that.queryShow = false;
      that.total = 0;
      that.$toast.loading({
        message: '加载中...',
        overlay: true,
        duration: 0
      });
      that.popupData = null;
      // if (id === that.typeId) return;
      that.page = 1;
      that.listData = [];
      that.typeId = id;
      // window.clearInterval(that.hotTacticInterval);
      // that.hotTacticInterval = null;
      that.chartList.forEach((item) => {
        if (item) {
          item.dispose();
        }
      });
      that.chartList = [];
      that.mnChartList.forEach((item) => {
        if (item) {
          item.dispose();
        }
      });
      that.mnChartList = [];

      that.$nextTick(function () {
        that.getData();
      });
    },
    // 因子滚动
    scrollYzFn: function () {
      this.loading = true;
      this.getData();
    },

    getData: function () {
      let that = this;
      let obj = {
        start: that.page,
        count: that.pageSize,
        type: that.typeId,
        type_info: compareVersions(that.$route.query.version , 9.69) ? 0 : 1 //0全部  1A股 2ETF
      };
      getMyFavor(obj)
        .then((res) => {
          that.$toast.clear();
          if (res.err === 200) {
            that.total = res.data.countData;
            if (obj.type === 'yz' && res.data.listData.length > 0) {
              that.getYzzs(res.data.listData);
            } else if (obj.type === 'cl' && res.data.listData.length > 0) {
              that.listData = [...that.listData, ...res.data.listData];
              that.$nextTick(function () {
                if (res.data.listData.length < 10) {
                  //是否已加载完成，加载完成后不再触发load事件
                  that.finished = true;
                } else {
                  that.loading = false;
                  that.page += 1;
                  that.finished = false;
                }
                that.getClHq();
                // that.hotTacticInterval = window.setInterval(() => {
                //   that.getClHq();
                // }, 60000);
              });
            } else if (obj.type === 'mn' && res.data.countData > 0) {
              that.listData = [...that.listData, ...res.data.listData];
              that.$nextTick(function () {
                if (res.data.listData.length < 10) {
                  //是否已加载完成，加载完成后不再触发load事件
                  that.finished = true;
                } else {
                  that.loading = false;
                  that.page += 1;
                  that.finished = false;
                }
                that.chartFn();
              });
            }
            that.finishedText = '没有更多了';
          } else {
            that.finished = true;
            that.loading = true;
            that.finishedText = '';
          }
          that.queryShow = true;
        })
        .catch(() => {
          that.finishedText = '';
          that.loading = true;
          that.finished = true;
          that.queryShow = true;
          that.$toast.clear();
        });
    },
    // 获取多因子走势
    getYzzs: function (data) {
      let that = this;
      let factors = data.map((item) => {
        return item.s_id;
      });
      factors = factors.toString().replaceAll(',', '_');
      getFactorTrend({ factors: factors }).then((res) => {
        if (res.err === 200) {
          let keys = Object.keys(res.data);

          that.loading = false;
          if (keys.length < 10) {
            //是否已加载完成，加载完成后不再触发load事件
            that.finished = true;
          } else {
            that.page += 1;
            that.finished = false;
          }

          keys.forEach((item) => {
            data.forEach((dataItem) => {
              if (item === dataItem.s_id) {
                dataItem.chartX = res.data[item].xAxis;
                dataItem.chartY = res.data[item].yAxis;
                dataItem.yearsData = res.data[item].yearsData;
              }
            });
          });
          that.listData = [...that.listData, ...data];
          that.$nextTick(function () {
            that.queryShow = true;
            that.chartFnyz();
            that.getHq();
            // that.hotTacticInterval = window.setInterval(() => {
            //   that.getHq();
            // }, 60000);
          });
        }
      });
    },
    // 因子走势图表
    chartFnyz: function () {
      let that = this;
      let chartData = that.listData;
      chartData.forEach((item, index) => {
        if (!that.chartList[index]) {
          let chartDom = document.getElementById('chartyz' + index);
          that.chartList[index] = that.$echarts.init(chartDom);
          window.addEventListener('resize', that.resizeHandler);
        }
        let xData = item.chartX;
        let dataY = item.chartY;
        let markLineData = item.chartY.length > 0 ? item.chartY[0] : 0;
        let color = item.yearsData > 0 ? ['#EF3939'] : ['#1EAC4E'];
        let option = {
          color: color,
          grid: {
            left: 0,
            top: 5,
            right: 0,
            bottom: 5
          },
          xAxis: {
            show: false,
            type: 'category',
            data: xData
          },
          yAxis: {
            show: false,
            type: 'value',
            min: function (minData) {
              return minData.min;
            },
            max: function (maxData) {
              return maxData.max;
            }
          },
          series: [
            {
              symbol: 'none',
              data: dataY,
              type: 'line',
              smooth: true,
              itemStyle: {
                lineStyle: {
                  color: '#000000' //改变折线颜色
                }
              },
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: item.yearsData > 0 ? 'rgba(239, 57, 57, .5)' : 'rgba(30, 172, 78, .5)' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: item.yearsData > 0 ? 'rgba(239, 57, 57, 0)' : 'rgba(30, 172, 78, 0)' // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markLine: {
                symbol: ['none', 'none'], // none为标线两端的样式为无，可更改
                data: [
                  {
                    silent: false,
                    yAxis: markLineData, // 表现自定义的位置，可赋值
                    label: {
                      position: 'end', // 表现内容展示的位置
                      formatter: '中文路均值', // 标线展示的内容
                      color: '#8C8C8C', // 展示内容颜色
                      show: false
                    },
                    lineStyle: {
                      type: 'dashed',
                      color: 'rgba(153, 153, 153, 1)',
                      width: 1
                    }, // 样式： 线型、颜色、线宽
                    emphasis: {
                      lineStyle: {
                        width: 1 // hover时的折线宽度
                      }
                    }
                  }
                ]
              }
            }
          ]
        };
        option && that.chartList[index].setOption(option);
      });
    },
    resizeHandler() {
      this.chartList.forEach((item) => {
        if (item) {
          item.resize();
        }
      });
      this.mnChartList.forEach((item) => {
        if (item) {
          item.resize();
        }
      });
    },
    // 获取行情数据
    getHq: function () {
      let that = this;
      let idKeys = that.listData.map((item) => {
        return item.s_id;
      });
      idKeys = idKeys.toString().replaceAll(',', '_');
      let obj = {
        type: 'yz',
        factorID: idKeys.replaceAll('_', ','),
        field: 'Desc,LongTouGu,KanDian,FactorCode,zhangdietongji,XiFenZhongLei'
      };
      getFactorHq(obj).then((res) => {
        if (res.err === 200) {
          let data = that.listData;
          res.data.forEach((item) => {
            data.forEach((dataItem, index) => {
              if (item.ID === dataItem.s_id) {
                that.$set(that.listData[index], 'Desc', item.Desc);
                that.$set(that.listData[index], 'FactorName', item.FactorName);
                if (item.LongTouGu) {
                  that.$set(that.listData[index], 'LongTouGu', item.LongTouGu.slice(0, 2));
                }
                that.$set(that.listData[index], 'RiZhangFu', item.RiZhangFu);
                that.$set(that.listData[index], 'XinHaoShuLiang', item.XinHaoShuLiang);
                if (item.ZhangDieTongJi) {
                  that.$set(that.listData[index], 'ZhangTingShu', item.ZhangDieTongJi[0]);
                  that.$set(that.listData[index], 'ZhangYuShu', item.ZhangDieTongJi[7]);
                }
                that.$set(that.listData[index], 'KanDian', item.KanDian);
                that.$set(that.listData[index], 'FactorCode', item.FactorCode);
                that.$set(that.listData[index], 'XiFenZhongLei', item.XiFenZhongLei);
              }
            });
          });
          that.listData = data;
        }
      });
    },

    // 获取策略行情
    getClHq: function () {
      let that = this;
      let idKeys = that.listData.map((item) => {
        return item.f_id_arr.replaceAll(',', '_');
      });
      idKeys = idKeys.toString();
      let obj = {
        type: 'cl',
        groupID: idKeys,
        field: 'Desc'
      };
      getFactorHq(obj).then((res) => {
        if (res.err === 200) {
          res.data.forEach((item) => {
            that.listData.forEach((allItem, index) => {
              if (item.ID.replaceAll('_', ',') === allItem.f_id_arr) {
                that.$set(that.listData[index], 'RiZhangFu', item.RiZhangFu);
                that.$set(that.listData[index], 'XinHaoShuLiang', item.XinHaoShuLiang);
              }
            });
          });
        }
      });
    },
    // 策略滚动处理
    scrollClFn: function () {
      let that = this;
      that.loading = true;
      that.getData();
    },
    // 创建图表
    chartFn: function () {
      let that = this;
      let dataList = that.listData;
      dataList.forEach((item, index) => {
        if (!that.mnChartList[index]) {
          let chartDom = document.getElementById('chartMn2' + index);
          that.mnChartList[index] = that.$echarts.init(chartDom);
          window.addEventListener('resize', that.resizeHandler);
        }
        let xData = item.lineData.xData;
        let dataSy = item.lineData.profitRate;
        let dataHs = item.lineData.hs300Rate;
        let option = {
          color: ['#286DF7', '#FF770C'],
          grid: {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
          },
          xAxis: {
            show: false,
            type: 'category',
            data: xData
          },
          yAxis: {
            show: false,
            type: 'value'
          },
          series: [
            {
              symbol: 'none',
              data: dataSy,
              type: 'line',
              smooth: true,
              itemStyle: {
                lineStyle: {
                  color: '#000000' //改变折线颜色
                }
              }
            },
            {
              symbol: 'none',
              data: dataHs,
              type: 'line',
              smooth: true,
              itemStyle: {
                lineStyle: {
                  color: '#FF770C' //改变折线颜色
                }
              },
              markLine: {
                symbol: ['none', 'none'], // none为标线两端的样式为无，可更改
                data: [
                  {
                    silent: false,
                    yAxis: 0, // 表现自定义的位置，可赋值
                    label: {
                      position: 'end', // 表现内容展示的位置
                      formatter: '中文路均值', // 标线展示的内容
                      color: '#8C8C8C', // 展示内容颜色
                      show: false
                    },
                    lineStyle: {
                      type: 'dashed',
                      color: that.themeStyleVs === 2 ? '#6b7687' : 'rgba(0, 0, 0, 0.2)',
                      width: 1
                    } // 样式： 线型、颜色、线宽
                  }
                ]
              }
            }
          ]
        };
        option && that.mnChartList[index].setOption(option);
      });
    },
    // 模拟交易处理
    scrollMnFn: function (e) {
      let that = this;
      that.loading = true;
      that.getData();
    },
    // 因子点击显示弹框
    yzProp: function (item) {
      let that = this;
      that.popupData = item;
      that.$nextTick(function () {
        that.popupShow = true;
      });
    },
    // 置顶按钮
    topMyFavorFn: function () {
      let that = this;
      let obj = {
        s_id: that.popupData.s_id
      };
      topMyFavor(obj).then((res) => {
        if (res.err === 200) {
          that.checkNav(that.typeId);
          that.$toast(res.msg);
          that.popupShow = false;

          that.listData = [];
          that.page = 1;
          that.loading = true;
          that.getData();
        }
      });
    },
    delFavorFn: function () {
      let that = this;
      let msg = that.typeId === 'yz' ? that.popupData.FactorName : that.popupData.s_name;
      that.dialogMessage = '是否确认取消关注' + "'" + msg + "'" + '？';
      that.dialogShow = true;
    },
    dialogFnConfirm: function () {
      this.delFavor();
    },
    // 取消关注
    delFavor: function () {
      let that = this;
      let data = that.popupData;
      that.page = 1;
      let type;
      switch (that.typeId) {
        case 'yz':
          type = 2;
          break;
        case 'cl':
          type = 1;
          break;
        case 'mn':
          type = 3;
          break;
      }
      let obj = {
        type: type,
        id: data.s_id
      };
      delMyFavor(obj).then((res) => {
        that.popupShow = false;
        if (res.err === 200) {
          that.checkNav(that.typeId);
          that.$toast(res.msg);
          if (that.typeId === 'yz') {
            if (typeof DzhAppJs != 'undefined') {
              DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
                'updateFactorFollowStatus',
                JSON.stringify({ factorId: data.s_id, followStatus: 0 }),
                ''
              );
            }
          }

          that.listData = [];
          that.loading = true;
          that.getData();
        }
      });
    },
    // 跳转策略详情页
    goClDetails: function (item) {
      let that = this;
      that.takeLinkType = 'cl';
      that.linkData = item;
      // if (localStorage.getItem('cl') === 'true') {
      that.$store.commit('setSmallTab', that.typeId);
      that.gotoUrlInfo('/clDetail', '', {
        s_id: item.s_id,
        type: 'follow',
        sourceType: true,
        themeStyleVs: that.themeStyleVs
      });
      // } else {
      //   that.takeName =
      //     '每次查看热门策略(包括关注和最近浏览)需消耗 5个慧豆，且今日内查看相同策略不会重复扣豆';
      //   that.takeBtnName = '继续查看';
      //   that.takeShow = true;
      // }
    },
    cancelBasis: function (e) {
      this.takeShow = e;
    },
    linkGo: function () {
      let that = this;
      let type = that.takeLinkType;
      let item = that.linkData;
      if (type === 'cl') {
        that.$store.commit('setSmallTab', that.typeId);
        that.gotoUrlInfo('/clDetail', '', {
          s_id: item.s_id,
          type: 'follow',
          sourceType: true,
          themeStyleVs: that.themeStyleVs
        });
      } else {
        that.$store.commit('setSmallTab', that.typeId);
        that.gotoUrlInfo('/mnDetail', '', {
          zj_id: item.s_id,
          type: 'follow',
          sourceType: true,
          themeStyleVs: that.themeStyleVs
        });
      }
      this.cancelBasis(false);
    },
    goMnDetails: function (item) {
      let that = this;
      that.takeLinkType = 'mn';
      if (item.lastProfit.status === 0) return;
      that.linkData = item;
      // if (localStorage.getItem('mn') === 'true') {
      that.$store.commit('setSmallTab', that.typeId);
      that.gotoUrlInfo('/mnDetail', '', {
        zj_id: item.s_id,
        type: 'follow',
        sourceType: true,
        themeStyleVs: that.themeStyleVs
      });
      // } else {
      //   that.takeName =
      //     '每次查看热门模拟交易(包括关注和最近浏览)需消耗 8个慧豆，且今日内查看相同策略不会重复扣豆';
      //   that.takeBtnName = '继续查看';
      //   that.takeShow = true;
      // }
    },
    goDetailYz: function (item) {
      let that = this;
      if ( !compareVersions(this.getUrlQuery('version'),9.66) && window.config.editionText !== '') {
        that.$emit('diagShow', true);
        return;
      }
      if (typeof DzhAppJs == 'undefined') {
        console.log('请在大智慧中打开');
      } else {
        that.$store.commit('setSmallTab', that.typeId);
        // 因子详情页 factorid 因子id，factorname 因子名称，factorcode 因子代码
        window.location.href =
          'dzh_browser_url&goto=0&screen=464&factorid=' +
          item.s_id +
          '&factorname=' +
          item.FactorName +
          '&factorcode=' +
          item.FactorCode;
      }
    }
  },
  beforeDestroy() {
    let that = this;
    // inobounce.disable();

    // window.clearInterval(that.hotTacticInterval);
    // that.hotTacticInterval = null;
    that.chartList.forEach((item) => {
      if (item) {
        item.dispose();
      }
    });
    that.chartList = [];
    that.mnChartList.forEach((item) => {
      if (item) {
        item.dispose();
      }
    });
    that.mnChartList = [];
    window.removeEventListener('resize', that.resizeHandler);
  }
};
</script>
<style lang="less" scoped>
.gz_page {
  width: 100%;
  height: 100%;
  padding-top: 12px;
  .type_nav_box {
    width: 100%;
    height: 27px;
    padding-left: 12px;
    li {
      display: inline-block;
      padding: 4px 16px;
      color: #222;
      background-color: #fff;
      margin-right: 8px;
      border-radius: 2px;
      font-size: 12px;
      &.active {
        background-color: #286df7;
        color: #fff;
      }
      &:last-child {
        margin-right: 8px;
      }
    }
  }
  .num_main {
    padding: 8px 0;
    font-size: 12px;
    color: #555;
    padding-left: 12px;
  }
  .content_main {
    width: 100%;
    height: calc(100% - 60px);
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .list_main {
      width: 100%;
      height: 100%;
    }
    .ul {
      padding: 0 0.32rem;
      li {
        display: inline-block;
        width: 100%;
        padding: 12px 16px;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 8px;
        margin-bottom: 8px;
        position: relative;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .top_img {
          position: absolute;
          top: 5px;
          left: 5px;
          width: 10px;
          height: 10px;
        }
        .tit {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 4px;
          span {
            font-size: 16px;
            font-weight: 600;
            color: #222;
          }
          img {
            display: inline-block;
            width: 24px;
            height: 24px;
          }
        }
        .xifen_box {
          display: inline-block;
          padding: 4px 8px;
          background: rgba(254, 116, 0, 0.1);
          border-radius: 4px;
          font-size: 12px;
          color: #fe7400;
          margin: 7px 0 6px 0;
        }
        .chart_main {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          .left {
            p {
              &:first-child {
                color: #222;
                font-size: 20px;
                font-weight: 500;
              }
              &:last-child {
                font-size: 12px;
                color: #999;
              }
            }
          }
          .right {
            display: flex;
            align-items: center;
            .chart_box {
              width: 155px;
              height: 48px;
              margin-right: 8px;
            }
            .one_year_box {
              background: #f7f8fa;
              padding: 2px 6px;
              border-radius: 8px 8px 8px 0px;
              &.red_bg {
                background-color: rgba(239, 57, 57, 0.1);
              }
              &.green_bg {
                background-color: rgba(30, 172, 78, 0.1);
              }
              p {
                font-size: 10px;
                color: #555;
              }
            }
          }
        }
        .cen_main {
          width: 100%;
          display: flex;
          align-items: center;
          margin-bottom: 4px;
          p {
            text-align: center;
            flex: 1;
            position: relative;
            &::after {
              content: ' ';
              position: absolute;
              width: 1px;
              height: 6px;
              background-color: #e5e5e5;
              right: 0;
              top: 50%;
              transform: translate(-50%, 0);
            }
            &:last-child {
              &::after {
                content: none;
              }
            }
            span {
              &:first-child {
                font-size: 12px;
                color: #999;
                margin-right: 4px;
              }
              &:last-child {
                font-size: 12px;
                color: #555;
              }
            }
          }
        }
        .long_main {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: row;
          flex-wrap: wrap;
          .long_li {
            width: 153px;
            height: 22px;
            background-color: #f7f8fa;
            border-radius: 4px;
            margin-bottom: 4px;
            padding: 0 12px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            span {
              font-size: 12px;
              color: #555;
              &:first-child {
                margin-right: 6px;
              }
            }
          }
        }
        .kd_main {
          padding-left: 6px;
          font-size: 12px;
          color: #555;
          img {
            width: 27px;
            height: 11px;
            margin-right: 4px;
            display: inline-block;
          }
        }
      }
    }
    &.cl_content_main {
      padding: 0 12px;
      .cl_main {
        width: 100%;
        background-color: #fff;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 15px 12px;
        box-sizing: border-box;
        margin-bottom: 8px;
        position: relative;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .top_img {
          position: absolute;
          top: 5px;
          left: 5px;
          width: 10px;
          height: 10px;
        }
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          .tit {
            font-size: 16px;
            color: #373a4d;
            font-weight: 500;
          }
          img {
            display: inline-block;
            width: 24px;
            height: 24px;
          }
        }
      }
      .intro_box {
        font-size: 12px;
        line-height: 16px;
        color: #666666;
        margin-bottom: 8px;
      }
      .detail_cante {
        width: 100%;
        .li_box {
          margin-bottom: 4px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          &:last-child {
            margin-bottom: 0;
          }
          div {
            width: 158px;
            padding: 9px 0;
            box-sizing: border-box;
            background: #f9f9f9;
            border-radius: 4px;
            text-align: center;
            p {
              span {
                font-size: 10px;
                color: #666666;
                margin-left: 4px;
              }
              &:first-child {
                font-weight: 500;
                font-size: 16px;
                color: #373a4d;
              }
              &:last-child {
                font-size: 12px;
                color: #999999;
                line-height: 14px;
              }
            }
          }
        }
      }
    }
    &.mn_content_main {
      padding: 0 12px;
      .cl_main {
        width: 100%;
        background-color: #fff;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 15px 12px;
        box-sizing: border-box;
        margin-bottom: 8px;
        position: relative;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .lose_box {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background-color: rgba(255, 255, 255, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9;
          .btn_show {
            display: inline-block;
            padding: 6px 16px;
            background: rgba(0, 0, 0, 0.4);
            border-radius: 24px;
            color: #fff;
            font-size: 16px;
          }
        }
        .top_img {
          position: absolute;
          top: 5px;
          left: 5px;
          width: 10px;
          height: 10px;
        }
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          .tit {
            font-size: 16px;
            color: #373a4d;
            font-weight: 500;
          }
          img {
            display: inline-block;
            width: 24px;
            height: 24px;
            z-index: 10;
          }
        }
      }
      .list_main {
        height: 100%;
        width: 100%;
        .main {
          margin-bottom: 8px;
        }
        .cen_main {
          width: 100%;
          margin-bottom: 4px;
          ul {
            width: 100%;
            display: flex;
            li {
              width: 106px;
              height: 52px;
              background: #f9f9f9;
              border-radius: 4px;
              margin-right: 4px;
              display: flex;
              align-items: center;
              flex-direction: column;
              justify-content: center;
              &:last-child {
                margin-right: 0;
              }
              p {
                &:first-child {
                  font-size: 16px;
                  // color: #EF3939;
                  font-weight: 500;
                }
                &:last-child {
                  font-size: 12px;
                  color: #999999;
                }
              }
            }
          }
        }
        .chart_box {
          width: 100%;
          height: 52px;
          background-color: #f8f8f8;
          margin-bottom: 2px;
        }
        .food_box {
          width: 100%;
          padding-left: 8px;
          font-size: 12px;
          color: #999999;
          line-height: 14px;
          .time_box {
            float: left;
          }
          .right_box {
            float: right;
            span {
              position: relative;
              &:first-child {
                margin-right: 17px;
                position: relative;
                &::before {
                  background-color: #286df7;
                }
              }
              &:last-child {
                &::before {
                  background-color: #ff770c;
                }
              }
              &::before {
                content: '';
                width: 4px;
                height: 4px;
                border-radius: 50%;
                position: absolute;
                top: 7px;
                left: -8px;
              }
            }
          }
        }
      }
    }
  }
  .popup_box {
    width: 100%;
    padding-top: 20px;
    box-sizing: border-box;
    .controls_ul {
      width: 100%;
      li {
        display: inline-block;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding-left: 16px;
        font-size: 16px;
        color: #555;
        border-bottom: 1px solid #e5e5e5;
        &:last-child {
          border: none;
        }
      }
    }
    .close_box {
      width: 100%;
      height: 50px;
      border-top: 1px solid #e5e5e5;
      text-align: center;
      line-height: 50px;
      color: #555;
      font-size: 16px;
    }
  }
}
.black_box {
  .type_nav_box {
    li {
      color: #e4e9fe;
      background-color: #1d202d;
      &.active {
        background-color: #3b85fe;
      }
    }
  }
  .num_main {
    color: #aab9d1;
  }
  .content_main {
    .ul {
      li {
        background: #181a23;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .tit {
          span {
            color: #e4e9fe !important;
          }
        }
        .xifen_box {
          background: rgba(254, 116, 0, 0.2);
        }
        .chart_main {
          .left {
            p {
              &:last-child {
                color: #6b7687;
              }
              &:first-child {
                color: #6b7687;
              }
            }
          }
          .right {
            .one_year_box {
              p {
                color: #aab9d1;
              }
            }
          }
        }
        .cen_main {
          p {
            &::after {
              background-color: rgba(255, 255, 255, 0.1);
            }
            span {
              &:first-child {
                color: #6b7687;
              }
              &:last-child {
                color: #aab9d1;
              }
            }
          }
        }
        .long_main {
          .long_li {
            background-color: #1d202d;
            span {
              color: #aab9d1;
            }
          }
        }
        .kd_main {
          color: #aab9d1;
        }
      }
    }
    &.cl_content_main {
      .cl_main {
        background-color: #181a23;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .top {
          .tit {
            color: #e4e9fe;
          }
        }
      }
      .intro_box {
        color: #aab9d1;
      }
      .detail_cante {
        .li_box {
          div {
            background-color: #1d202d;
            p {
              &:first-child {
                color: #e4e9fe;
                span {
                  color: #aab9d1;
                }
              }
              &:last-child {
                color: #6b7687;
              }
            }
          }
        }
      }
    }
    &.mn_content_main {
      .cl_main {
        background-color: #181a23;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .lose_box {
          background: rgba(24, 26, 35, 0.4);
        }
        .top {
          .tit {
            color: #e4e9fe;
          }
        }
      }
      .list_main {
        .cen_main {
          ul {
            li {
              background-color: #1d202d;
              p {
                &:first-child {
                  color: #e4e9fe;
                }
                &:last-child {
                  color: #6b7687;
                }
              }
            }
          }
        }
        .chart_box {
          background-color: #1d202d;
        }
        .food_box {
          .time_box {
            color: #6b7687;
          }
          .right_box {
            span {
              color: #6b7687;
            }
          }
        }
      }
    }
  }
}
</style>
<style></style>
